module.exports = __webpack_public_path__ + "media/assets/good_at/rails-4191e501dc0dfd5afb28d557cb104d6c.png";